import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBarClosed from "./SideBarClosed";
import SideBarOpen from "./SideBarOpen";
import { fetchMenu } from "../features/global/globalSlice";
import {
  getOrganizationDetails,
  getUserDetails,
} from "../features/fetch/fetchSlice";

export default function SideBar() {
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {}, [sideMenuCollapsed]);

  useEffect(() => {
    dispatch(fetchMenu());
    dispatch(
      getOrganizationDetails({
        url: "api/v1/org/fetch-organisation",
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      getUserDetails({
        usrId: user?.usrId,
        usrEmail: null,
        usrNationalId: null,
        url: "api/v2/users/get",
      })
    );
  }, [user]);

  if (sideMenuCollapsed) return <SideBarClosed />;

  return <SideBarOpen />;
}
